// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle__GSxwl","Toggle__reverse":"Toggle_Toggle__reverse__ysfbH"};